(function() {
    const menuEl = document.querySelector('.main-menu--main');
    if (!menuEl) return;

    let submenuIdCounter = 0;

    const isToggleOnlyHref = (href) => {
        if (!href) return true;
        const trimmed = href.trim();
        return trimmed === '' || trimmed === '#';
    };

    const getSubmenu = (item) => item.querySelector(':scope > .sub-menu, :scope > ul');

    const ensureSubmenuId = (submenu) => {
        if (!submenu) return null;
        if (!submenu.id) {
            submenuIdCounter += 1;
            submenu.id = 'main-submenu-' + submenuIdCounter;
        }
        return submenu.id;
    };

    const getLinkLabel = (link) => {
        if (!link) return '';
        return (link.textContent || '').trim();
    };

    const getToggleLabel = (linkLabel, isOpen) => {
        const name = linkLabel || 'submenu';
        return isOpen ? 'Submenu ' + name + ' sluiten' : 'Submenu ' + name + ' openen';
    };

    const setExpanded = (item, isOpen) => {
        item.classList.toggle('is-open', isOpen);

        const link = item.querySelector(':scope > a');
        const linkLabel = getLinkLabel(link);
        const toggleBtn = item.querySelector(':scope > .main-menu__submenu-toggle');

        if (toggleBtn) {
            toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            toggleBtn.setAttribute('aria-label', getToggleLabel(linkLabel, isOpen));
        }

        if (link && isToggleOnlyHref(link.getAttribute('href'))) {
            link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
    };

    const closeItem = (item) => {
        setExpanded(item, false);

        [...item.querySelectorAll('.menu-item-has-children.is-open')].forEach(child => {
            setExpanded(child, false);
        });
    };

    const closeAll = () => {
        [...menuEl.querySelectorAll('.menu-item-has-children.is-open')].forEach(item => {
            setExpanded(item, false);
        });
    };

    const openItem = (item) => {
        const parentList = item.parentElement;
        if (parentList) {
            [...parentList.children].forEach(sibling => {
                if (sibling !== item && sibling.classList.contains('is-open')) closeItem(sibling);
            });
        }

        setExpanded(item, true);
    };

    const toggleItem = (item) => {
        if (item.classList.contains('is-open')) closeItem(item);
        else openItem(item);
    };

    const focusTrigger = (item) => {
        const toggleBtn = item.querySelector(':scope > .main-menu__submenu-toggle');
        const link = item.querySelector(':scope > a');

        if (toggleBtn) toggleBtn.focus();
        else if (link) link.focus();
    };

    const getFirstSubmenuLink = (item) => {
        const submenu = getSubmenu(item);
        if (!submenu) return null;
        return submenu.querySelector('a, button');
    };

    [...menuEl.querySelectorAll('li.menu-item-has-children')].forEach(item => {
        if (item.closest('.main-menu__theme-switcher')) return;

        const link = item.querySelector(':scope > a');
        if (!link) return;

        const toggleOnly = isToggleOnlyHref(link.getAttribute('href'));
        const submenu = getSubmenu(item);
        const submenuId = ensureSubmenuId(submenu);
        const linkLabel = getLinkLabel(link);

        const toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.className = 'main-menu__submenu-toggle';
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.setAttribute('aria-haspopup', 'true');
        toggleBtn.setAttribute('aria-label', getToggleLabel(linkLabel, false));
        if (submenuId) toggleBtn.setAttribute('aria-controls', submenuId);

        link.after(toggleBtn);

        if (toggleOnly) {
            link.setAttribute('role', 'button');
            link.setAttribute('aria-expanded', 'false');
            link.setAttribute('aria-haspopup', 'true');
            if (submenuId) link.setAttribute('aria-controls', submenuId);

            link.addEventListener('click', e => {
                e.preventDefault();
                toggleItem(item);
            });

            link.addEventListener('keydown', e => {
                if (e.key !== 'Enter' && e.key !== ' ') return;
                e.preventDefault();
                toggleItem(item);
            });
        }

        toggleBtn.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation();
            toggleItem(item);
        });

        // ArrowDown opens and moves focus into the submenu
        const handleArrowDown = (e) => {
            if (e.key !== 'ArrowDown') return;
            e.preventDefault();

            if (!item.classList.contains('is-open')) openItem(item);

            const firstLink = getFirstSubmenuLink(item);
            if (firstLink) firstLink.focus();
        };

        toggleBtn.addEventListener('keydown', handleArrowDown);
        if (toggleOnly) link.addEventListener('keydown', handleArrowDown);
    });

    document.addEventListener('click', e => {
        if (!menuEl.contains(e.target)) closeAll();
    });

    document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;

        const openItems = [...menuEl.querySelectorAll('.menu-item-has-children.is-open')];
        if (!openItems.length) return;

        const focused = document.activeElement;
        let target = null;

        // Close the deepest open item that contains focus
        for (let i = openItems.length - 1; i >= 0; i--) {
            if (openItems[i].contains(focused)) {
                target = openItems[i];
                break;
            }
        }

        // Or close the deepest open item when focus is elsewhere in the menu
        if (!target && menuEl.contains(focused)) {
            target = openItems[openItems.length - 1];
        }

        if (!target) {
            closeAll();
            return;
        }

        closeItem(target);
        focusTrigger(target);
    });
})();
